import axios from "axios";
import { NSBarNotificationColor, NSBarNotificationProps, NotificationType } from "../components/NSBarNotification";
import { BaseUUID, IStorage, TimeOperation } from "namirasoft-core";
import { Mutex } from 'async-mutex';

export class NSNotifier
{
    private static mutex_mofify: Mutex = new Mutex();
    private static mutex_set: Mutex = new Mutex();
    private storage: IStorage;
    private changeState: () => void;
    public timeout: number = 5000;
    constructor(storage: IStorage, changeState: () => void)
    {
        this.storage = storage;
        this.changeState = changeState;
        this.onChangeState = this.onChangeState.bind(this);
        this.getNotifications = this.getNotifications.bind(this);
        this.setNotifications = this.setNotifications.bind(this);
        this.delNotification = this.delNotification.bind(this);
        this.notify = this.notify.bind(this);
        this.onInformation = this.onInformation.bind(this);
        this.onSuccess = this.onSuccess.bind(this);
        this.onWarning = this.onWarning.bind(this);
        this.onError = this.onError.bind(this);
    }
    onChangeState()
    {
        this.changeState();
    }
    getNotifications(): NSBarNotificationProps[]
    {
        let ans: NSBarNotificationProps[] = [];
        let value = this.storage.get("ns-notifications", "");
        if (value)
            ans = JSON.parse(value);
        let now = new Date();
        ans = ans.filter(x =>
        {
            if (x.expired_at)
            {
                let expired_at = new Date(x.expired_at);
                return expired_at >= now;
            }
            return false;
        })
        return ans;
    }
    setNotifications(notifications: NSBarNotificationProps[], timout?: number): void
    {
        NSNotifier.mutex_set.runExclusive(() =>
        {
            notifications.forEach(n =>
            {
                if (!n.expired_at)
                    n.expired_at = TimeOperation.millisecondsLater(timout ?? this.timeout, new Date());
            });
            this.storage.set("ns-notifications", JSON.stringify(notifications));
            this.onChangeState();
        });
    }
    delNotification(id: string): void
    {
        NSNotifier.mutex_mofify.runExclusive(() =>
        {
            let notifications: NSBarNotificationProps[] = this.getNotifications();
            notifications = notifications.filter(x => x.id !== id);
            this.setNotifications(notifications);
        });
    }
    private notify(message: NSBarNotificationProps, timout?: number) 
    {
        NSNotifier.mutex_mofify.runExclusive(() =>
        {
            let notifications: NSBarNotificationProps[] = this.getNotifications();
            notifications.push(message);
            this.setNotifications(notifications, timout);
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        });
        setTimeout(() =>
        {
            this.delNotification(message.id);
        }, timout ?? this.timeout);
    }
    onInformation(text: string, timout?: number) 
    {
        let id = BaseUUID.uuid();
        this.notify({ id, text, type: NotificationType.Information, color: NSBarNotificationColor.GRAY }, timout);
    }
    onSuccess(text: string, timout?: number) 
    {
        let id = BaseUUID.uuid();
        this.notify({ id, text, type: NotificationType.Success, color: NSBarNotificationColor.GREEN }, timout);
    }
    onWarning(text: string, timout?: number) 
    {
        let id = BaseUUID.uuid();
        this.notify({ id, text, type: NotificationType.Warning, color: NSBarNotificationColor.YELLOW }, timout);
    }
    onError(error: Error | string, timout?: number) 
    {
        let id = BaseUUID.uuid();
        let text: string = "";
        if (error instanceof Error)
        {
            text = error.message;
            if (axios.isAxiosError(error))
                if (error.response?.data)
                    text = error.response.data;
        }
        else
            text = error;
        this.notify({ id, text, type: NotificationType.Error, color: NSBarNotificationColor.RED }, timout);
    }
}